export default __webpack_public_path__ + "images/DP.2ba18c4.png";